import classNames from 'classnames'
import React, { PureComponent } from 'react'
import { Interpolate } from 'react-i18next'
import { x } from '../../helpers/localization'
import '../../styles/leaflet.scss'
import CloseDialogButton from './CloseDialogButton'
import styles from './ViewSupply.scss'

type IHeader_Props = {
    title: string,
    selectedBuildingId: string | null,
    dropSelection: () => void,
    maxLevel: number,
    level: number,
    name: string,
}
type IHeader_State = {}

class Header extends PureComponent<IHeader_Props, IHeader_State> {
    render() {
        return (
            <div
                className={classNames(styles.buildingTopInfo, this.props.selectedBuildingId && styles.isShow)}
                onMouseOver={(e) => {
                    if (window.tooltipProvider) {
                        window.tooltipProvider.hide()
                    }
                }}
            >
                <div className={styles.headerInlineWrapper}>
                    <div className={styles.headerIconWrapper}>
                        <div className={styles[`${this.props.name}Icon`]} />
                    </div>
                    <div className={styles.headerTitleWrapper}>
                        <div className={styles.headerTitle}>{this.props.title}</div>
                        <div className={styles.headerUpgrades}>
                            <Interpolate
                                i18nKey={x('Улучшений: %(level)s из %(maxLevel)s')}
                                level={this.props.level}
                                maxLevel={this.props.maxLevel}
                                parent={'p'}
                            />
                        </div>
                    </div>
                    <CloseDialogButton onClick={this.props.dropSelection} />
                </div>
            </div>
        )
    }
}

export default Header